import React from "react";
import { useSelector } from "react-redux";
import ToolGuidePanel from "./ToolGuidePanel";

/**
 * Sidebar Tool Guide card only — no nav button.
 * Visible when a bucket is open; hidden when all buckets are closed.
 */
const ToolGuideSidebarItem = () => {
  const { isPanelOpen, bucketName } = useSelector((state) => state.toolGuide);

  if (!isPanelOpen || !bucketName) return null;

  return (
    <div className="flex flex-col w-full min-w-0 px-0.5 flex-shrink-0">
      <ToolGuidePanel key={bucketName} />
    </div>
  );
};

export default ToolGuideSidebarItem;
